
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.75 27.43h-20a1 1 0 01-1-1V13.18a1 1 0 011-1h20a1 1 0 011 1v13.25a1 1 0 01-1 1zm-1-13.25h-18v11.25h18V14.18zM36.21 49.1h11.08a1 1 0 001-1V29.33a1 1 0 00-1-1H36.21a1 1 0 00-1 1V48.1a1 1 0 001 1zm1-18.77h9.08V47.1h-9.08V30.33zM33.75 49.1h-20a1 1 0 01-1-1V29.33a1 1 0 011-1H24.2a1 1 0 011 1v9.06h8.55a1 1 0 011 1v8.71a1 1 0 01-1 1zM23.2 30.33h-8.45l.02 16.77h18v-6.71H24.2a1 1 0 01-1-1v-9.06z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.77 28.33h-7a1 1 0 00-1 1v7.32a1 1 0 001 1h7a1 1 0 001-1v-7.32a1 1 0 00-1-1zm-1 7.32h-5v-5.32h5v5.32zM47.29 27.43H36.21a1 1 0 01-1-1V13.18a1 1 0 011-1h11.08a1 1 0 011 1v13.25a1 1 0 01-1 1zm-1-13.25h-9.08v11.25h9.08V14.18z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 9h38.9a1 1 0 011 1v40.89a1 1 0 01-1 1H11a1 1 0 01-1-1V10a1 1 0 011-1zm1 40.89h36.9V11H12v38.89z"}})])
          )
        }
      }
    